import {
    FETCH_COMPANY_ORDERS
} from '../../actions/types';

const INITIAL_STATE = {
    timedOrders: [],
    completedOrders: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_COMPANY_ORDERS:
            return action.payload;
        default:
            return state;
    }
};